import DeliveryTruck01Icon from "@hugeicons/core-free-icons/DeliveryTruck01Icon";
import Cash01Icon from "@hugeicons/core-free-icons/Cash01Icon";
import PackageProcessIcon from "@hugeicons/core-free-icons/PackageProcessIcon";
import UserMultipleIcon from "@hugeicons/core-free-icons/UserMultipleIcon";
import Table01Icon from "@hugeicons/core-free-icons/Table01Icon";
import InjectionIcon from "@hugeicons/core-free-icons/InjectionIcon";
import { LOGISTICS_ROLES } from "../constants/roles";

// Logistics Console nav (`.scratch/logistics-dashboard/IMPLEMENTATION.md`).
//
// Three entries, in workflow order: an order becomes a shipment, the shipment moves through
// the queue, COD is the money lens over it.
//
// Orders leads the SIDEBAR but is not the landing route — HANDOFF.md is explicit that
// Delivery Queue "should remain the default landing view", so routes.jsx still redirects
// there. Sidebar order and landing route are deliberately different things here.
//
// COD Watch is a sibling entry rather than a filter chip on Delivery Queue because the
// prototype's HANDOFF.md treats it as "a valid alternate lens on the same shipment set" and
// keeps it in the sidebar. Both render the same page component; only the isCod filter differs.
//
// ROLES: LOGISTICS_ROLES. Was PHARMACY_ROLES, matching the legacy /delivery page's audience. The finance console
// carries the same placeholder and the same unresolved question — if logistics is a distinct
// team, it needs a distinct role.
export const LOGISTICS_NAV = [
    { key: "orders", label: "Orders", path: "/v2/logistics/orders", icon: PackageProcessIcon, roles: LOGISTICS_ROLES },
    { key: "deliveries", label: "Delivery Queue", path: "/v2/logistics/deliveries", icon: DeliveryTruck01Icon, roles: LOGISTICS_ROLES },
    { key: "cod", label: "COD Watch", path: "/v2/logistics/cod", icon: Cash01Icon, roles: LOGISTICS_ROLES },
    // Order Tracking Sheet — the legacy /order-tracking-sheet screen, reused as-is.
    { key: "tracking-sheet", label: "Order Tracking Sheet", path: "/v2/logistics/tracking-sheet", icon: Table01Icon, roles: LOGISTICS_ROLES },
    { key: "glp1", label: "GLP-1 Dashboard", path: "/v2/logistics/glp1", icon: InjectionIcon, roles: LOGISTICS_ROLES },
    // Users — the legacy /users screen, reused as-is (see routes.jsx).
    { key: "users", label: "Users", path: "/v2/logistics/users", icon: UserMultipleIcon, roles: LOGISTICS_ROLES },
];
